import "../../../FhInputField.css";
import { ref, onMounted, openBlock, createElementBlock, mergeProps } from "vue";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhInputField",
  emits: ["update:modelValue", "mounted"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const internalInputRef = ref(null);
    onMounted(() => {
      emit("mounted", internalInputRef.value);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("input", mergeProps({ class: "fh-input-field" }, _ctx.$attrs, {
        ref_key: "internalInputRef",
        ref: internalInputRef
      }), null, 16);
    };
  }
};
const FhInputField = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a46add51"]]);
export {
  FhInputField as default
};
//# sourceMappingURL=FhInputField.mjs.map
